import {
  AppSettingsHomePageDTO,
  AppSettingsNavigationDTO,
  ClubClassesSettingsDTO,
} from "@gymflow/types";
import { mutationOptions, QueryKey, queryOptions } from "@tanstack/react-query";

import { clubQueryKeys } from "../../../hooks";
import { api } from "../../api";
import { queryClient } from "../../QueryClient";

const keys = {
  all: () => ["staffApiAppSettings"] as QueryKey,
  classes: () => [...keys.all(), "classes"] as QueryKey,
  navigation: () => [...keys.all(), "navigation"] as QueryKey,
  homePage: () => [...keys.all(), "homePage"] as QueryKey,
};

export const staffApiAppSettings = {
  keys,
  queries: {
    classes: () =>
      queryOptions({
        queryKey: keys.classes(),
        queryFn: async () => {
          return (
            await api.get<ClubClassesSettingsDTO>(`/app-settings/classes`)
          ).data;
        },
      }),
    navigation: () =>
      queryOptions({
        queryKey: keys.navigation(),
        queryFn: async () => {
          return (
            await api.get<AppSettingsNavigationDTO>(`/app-settings/navigation`)
          ).data;
        },
      }),
    homePage: () =>
      queryOptions({
        queryKey: keys.homePage(),
        queryFn: async () => {
          return (
            await api.get<AppSettingsHomePageDTO>(`/app-settings/home-page`)
          ).data;
        },
      }),
  },
  infiniteQueries: {},
  mutations: {
    updateClassesSettings: () =>
      mutationOptions({
        mutationFn: async (params: ClubClassesSettingsDTO) =>
          (
            await api.patch<ClubClassesSettingsDTO>(
              `/app-settings/classes`,
              params,
            )
          ).data,
        onSettled: async () => {
          await Promise.all([
            queryClient.invalidateQueries({
              queryKey: clubQueryKeys.all(),
            }),
            queryClient.invalidateQueries({
              queryKey: keys.all(),
            }),
          ]);
        },
      }),
    updateNavigationSettings: () =>
      mutationOptions({
        mutationFn: async (params: AppSettingsNavigationDTO) =>
          (
            await api.patch<AppSettingsNavigationDTO>(
              `/app-settings/navigation`,
              params,
            )
          ).data,
        onSettled: async () => {
          await Promise.all([
            queryClient.invalidateQueries({
              queryKey: clubQueryKeys.all(),
            }),
            queryClient.invalidateQueries({
              queryKey: keys.all(),
            }),
          ]);
        },
      }),
    updateHomePageSettings: () =>
      mutationOptions({
        mutationFn: async (params: AppSettingsHomePageDTO) =>
          (
            await api.patch<AppSettingsHomePageDTO>(
              `/app-settings/home-page`,
              params,
            )
          ).data,
        onSettled: async () => {
          await Promise.all([
            queryClient.invalidateQueries({
              queryKey: clubQueryKeys.all(),
            }),
            queryClient.invalidateQueries({
              queryKey: keys.all(),
            }),
          ]);
        },
      }),
  },
};
